const headersDevice = [
  {
    text: 'id',
    value: 'id',
  },
  {
    text: 'Производитель',
    value: 'manufacturer',
  },
  {
    text: 'Модель',
    value: 'model',
  },
  {
    text: 'ip-адрес',
    value: 'ip_address',
  },
  {
    text: 'mac-адрес',
    value: 'mac_address',
  },
  {
    text: 'Серийный номер',
    value: 'serial_number',
  },
  {
    text: 'Последнее обновление',
    value: 'updatedAt',
  },
  {
    text: '',
    value: 'actions',
  },
];

const headersAbonent = [
  {
    text: 'Квартира',
    value: 'apartment',
  },
  {
    text: 'Телефон',
    value: 'telephone',
  },
  {
    text: 'Ключ',
    value: 'keys.0.code',
  },
  {
    text: 'Статус',
    value: 'status',
  },
];
const headersJournalBeward = [
  {
    text: 'Код ключа',
    value: 'code',
  },
  {
    text: 'Статус',
    value: 'OpenDoor',
  },
  {
    text: 'Дата и время',
    value: 'time',
  },
];
const headersJournal = [
  {
    text: 'id',
    value: 'id',
    align: 'center',
  },
  {
    text: 'Имя',
    value: 'Name',
    align: 'center',
  },
  {
    text: 'Код',
    value: 'Code',
    align: 'center',
  },
  {
    text: 'Тип',
    value: 'Type',
    align: 'center',
  },
  {
    text: 'Статус',
    value: 'Status',
    align: 'center',
  },
  {
    text: 'Дата и время',
    value: 'Date',
    align: 'center',
  },
];
const headersJournal3434 = [
  {
    text: 'id',
    value: 'id',
    align: 'center',
  },
  {
    text: 'Имя',
    value: 'Name',
    align: 'center',
  },
  {
    text: 'Код',
    value: 'Code',
    align: 'center',
  },
  {
    text: 'Номер двери',
    value: 'relay',
    width: '12%',
    align: 'center',
  },
  {
    text: 'Тип',
    value: 'Type',
    align: 'center',
  },
  {
    text: 'Статус',
    value: 'Status',
    align: 'center',
  },
  {
    text: 'Дата и время',
    value: 'Date',
    align: 'center',
  },
];
const headersJournalSip = [
  {
    text: 'Квартира',
    value: 'name',
    align: 'center',
  },
  {
    text: 'Тип',
    value: 'type',
    align: 'center',
  },
  {
    text: 'Номер',
    value: 'number',
    align: 'center',
  },
  {
    text: 'Дата и время',
    value: 'date',
    align: 'center',
  },
];
const headersSipRV3434 = [
  {
    text: 'Номер ячейки коммутатора',
    width: '16%',
    sortable: false,
    value: 'apartment',
    align: 'center',
  },
  {
    text: 'Тип',
    value: 'type',
    align: 'center',
  },
  {
    text: 'Статус',
    value: 'status',
    align: 'center',
  },
  {
    text: 'Номер',
    value: 'number',
    align: 'center',
  },
  {
    text: 'Дата и время',
    value: 'date',
    align: 'center',
  },
];
const headersSipBeward = [
  {
    text: 'id',
    width: '10%',
    value: 'id',
    align: 'center',
  },
  {
    text: 'Номер кватиры',
    width: '10%',
    sortable: false,
    value: 'apartment_number',
    align: 'center',
  },
  {
    text: 'Открытие двери и способ',
    value: 'door',
    align: 'center',
    sortable: false,
  },
  {
    text: 'Статус звонка и способ ответа',
    value: 'call',
    align: 'center',
    sortable: false,
  },
  {
    text: 'Дата и время начала звонка',
    value: 'start_time',
    align: 'center',
  },
];
const headersRulesRubetek3434 = [
  {
    text: 'Номер квартиры',
    value: 'Prefix',
    align: 'center',
    width: '6%',
  },
  {
    text: 'sip логин',
    value: 'Login',
    align: 'center',
    width: '8%',
    sortable: false,
  },
  {
    text: 'Телефон',
    value: 'telephone',
    align: 'center',
    width: '15%',
    sortable: false,
  },
  {
    text: 'Ключ',
    value: 'key',
    align: 'center',
    width: '12%',
    sortable: false,
  },
  {
    text: 'Комментарий',
    value: 'Comment',
    align: 'center',
    sortable: false,
    width: '15%',
  },
  {
    text: 'Пер. устройство',
    value: 'IsActive',
    align: 'center',
    class: 'table-custom-header wrap-text',
    width: '5%',
    sortable: false,
  },
  {
    text: 'Моб. приложения',
    value: 'status',
    align: 'center',
    width: '5%',
    sortable: false,
  },
  {
    text: 'Запрет активации ГРЗ',
    value: 'forbid_car_number_activation',
    align: 'center',
    class: 'table-custom-header wrap-text',
    width: '5%',
    sortable: false,
  },
];
const headersRulesRubetek3438 = [
  {
    text: 'id',
    value: 'ID',
    align: 'center',
    width: '5%',
  },
  {
    text: 'Номер квартиры',
    value: 'Prefix',
    align: 'center',
    class: 'table-custom-header wrap-text',
    width: '4%',
    sortable: false,
  },
  {
    text: 'sip логин',
    value: 'Login',
    align: 'center',
    class: 'table-custom-header wrap-text',
    width: '4%',
    sortable: false,
  },
  {
    text: 'sip логин 2',
    value: 'Replace',
    align: 'center',
    class: 'table-custom-header',
    width: '4%',
    sortable: false,
  },
  {
    text: 'Телефон',
    value: 'telephone',
    align: 'center',
    width: '15%',
    sortable: false,
  },
  {
    text: 'Ключ',
    value: 'key',
    align: 'center',
    width: '12%',
    sortable: false,
  },
  {
    text: 'Аналог',
    value: 'Replace5',
    align: 'center',
    class: 'table-custom-header',
    sortable: false,
  },
  {
    text: 'Комментарий',
    value: 'Comment',
    align: 'center',
    width: '25%',
    sortable: false,
  },
  {
    text: 'Пер. устройство',
    value: 'IsActive',
    align: 'center',
    class: 'table-custom-header wrap-text',
    width: '5%',
    sortable: false,
  },
  {
    text: 'Моб. приложения',
    value: 'status',
    align: 'center',
    width: '5%',
    sortable: false,
  },
  {
    text: 'Запрет активации ГРЗ',
    value: 'forbid_car_number_activation',
    align: 'center',
    class: 'table-custom-header wrap-text',
    width: '5%',
    sortable: false,
  },
];
const headersRulesBeward = [
  {
    text: 'Номер квартиры',
    value: 'Number',
    align: 'center',
    width: '6%',
  },
  {
    text: 'sip логин',
    value: 'Phone1',
    align: 'center',
    width: '6%',
    sortable: false,
  },
  {
    text: 'sip логин 2',
    value: 'Phone2',
    align: 'center',
    width: '6%',
    sortable: false,
  },
  {
    text: 'Телефон',
    value: 'telephone',
    align: 'center',
    width: '10%',
    sortable: false,
  },
  {
    text: 'Ключ',
    value: 'key',
    align: 'center',
    width: '5%',
    sortable: false,
  },
  {
    text: 'Комментарий',
    value: 'Comment',
    align: 'center',
    width: '15%',
    sortable: false,
  },
  {
    text: 'Пер. устройство',
    value: 'PhonesActive',
    align: 'center',
    class: 'table-custom-header wrap-text',
    width: '5%',
    sortable: false,
  },
  {
    text: 'Моб. приложения',
    value: 'status',
    align: 'center',
    width: '5%',
    sortable: false,
  },
  {
    text: 'Запрет активации ГРЗ',
    value: 'forbid_car_number_activation',
    align: 'center',
    class: 'table-custom-header wrap-text',
    width: '5%',
    sortable: false,
  },
];

const headersRulesShortRubetek3434 = [
  {
    text: 'Номер квартиры',
    value: 'Prefix',
    align: 'center',
  },
  {
    text: 'sip логин',
    value: 'Login',
    align: 'center',
    sortable: false,
  },
  {
    text: 'Комментарий',
    value: 'Comment',
    align: 'center',
    sortable: false,
  },
];
const headersRulesShortRubetek3438 = [
  {
    text: 'id',
    value: 'ID',
    align: 'center',
  },
  {
    text: 'Номер квартиры',
    value: 'Prefix',
    align: 'center',
    class: 'table-custom-header wrap-text',
    sortable: false,
  },
  {
    text: 'sip логин',
    value: 'Login',
    align: 'center',
    class: 'table-custom-header wrap-text',
    sortable: false,
  },
  {
    text: 'sip логин 2',
    value: 'Replace',
    align: 'center',
    class: 'table-custom-header',
    sortable: false,
  },
  {
    text: 'Комментарий',
    value: 'Comment',
    align: 'center',
    sortable: false,
  },
];
const headersRulesShortBeward = [
  {
    text: 'Номер квартиры',
    value: 'Number',
    align: 'center',
  },
  {
    text: 'sip логин',
    value: 'Phone1',
    align: 'center',
    sortable: false,
  },
  {
    text: 'sip логин 2',
    value: 'Phone2',
    align: 'center',
    sortable: false,
  },
  {
    text: 'Комментарий',
    value: 'Comment',
    align: 'center',
    sortable: false,
  },
];

const headersKeys = [
  {
    text: 'id',
    value: 'id',
    align: 'center',
  },
  {
    text: 'Название ключа',
    value: 'name',
    align: 'center',
  },
  {
    text: 'Код ключа',
    value: 'code',
    align: 'center',
  },
  {
    text: 'Универсальный',
    value: 'universal',
    align: 'center',
  },
  {
    text: 'Комментарий',
    value: 'comment',
    align: 'center',
  },
  {
    text: '',
    value: 'actions',
  },
];
const headersSip = [
  {
    text: 'ID',
    align: 'start',
    value: 'id',
  },
  {
    text: 'Предыдущий статус',
    value: 'old_sip_status',
  },
  {
    text: 'Новый статус',
    value: 'new_sip_status',
  },
  {
    text: 'Дата изменения',
    value: 'created_at',
  },
];
const tempCodeProvisionHistoryHeaders = [
  { text: 'id', value: 'id' },
  { text: 'Дата и время', value: 'event_at', sortable: false },
  { text: 'Источник', value: 'channel_label', sortable: false },
  { text: 'Квартира', value: 'apartment', sortable: false },
  { text: 'Кто выдал', value: 'user_name', sortable: false },
  {
    text: '',
    value: 'detail_info',
    sortable: false,
    align: 'center',
    width: '56px',
    class: 'temp-code-history-col-detail',
    cellClass: 'temp-code-history-col-detail',
  },
];
const tempCodeProvisionHistoryHeadersWithAddress = [
  { text: 'id', value: 'id' },
  { text: 'Дата и время', value: 'event_at', sortable: false },
  { text: 'Источник', value: 'channel_label', sortable: false },
  { text: 'Адрес домофона', value: 'doorphone_address', sortable: false },
  { text: 'Квартира', value: 'apartment', sortable: false },
  { text: 'Кто выдал', value: 'user_name', sortable: false },
  {
    text: '',
    value: 'detail_info',
    sortable: false,
    align: 'center',
    width: '56px',
    class: 'temp-code-history-col-detail',
    cellClass: 'temp-code-history-col-detail',
  },
];
const actionsJournal = [
  {
    text: 'id',
    value: 'id',
  },
  {
    text: 'Наименование',
    value: 'title',
    sortable: false,
  },
  {
    text: 'абонент',
    value: 'abonent.telephone',
    sortable: false,
  },
  {
    text: 'квартира',
    value: 'abonent.apartment',
    sortable: false,
  },
  {
    text: 'дата и время',
    value: 'createdAt',
    sortable: false,
  },
  {
    text: 'Автор',
    value: 'user.name',
    sortable: false,
  },
];
const mobileHeadersJournal = [
  {
    text: 'id',
    value: 'id',
    align: 'center',
  },
  {
    text: 'дверь',
    value: 'door.name',
    sortable: false,
    align: 'center',
  },
  {
    text: 'квартира',
    value: 'abonent.apartment',
    sortable: false,
    align: 'center',
  },
  {
    text: 'абонент',
    value: 'abonent.telephone',
    sortable: false,
    align: 'center',
  },
  {
    text: 'дата и время',
    value: 'createdAt',
    sortable: false,
    align: 'center',
  },
];
const TYPE = {
  0: 'Все',
  1: 'Исходящий',
  2: 'Входящий',
  3: 'Пропущенный',
};

const CALL_STATUS = {
  1: 'Принят',
  2: 'Пропуск',
};

const CALL_TYPES = {
  0: 'SIP',
  1: 'Аналоговый',
  100: 'SIP прямой вызов',
};

const JOURNAL_TYPES = {
  1: 'Ключ',
  2: 'Перс. код',
  3: 'Общий код',
  4: 'Открытие через API',
  5: 'DTMF',
  6: 'Трубка',
};

const JOURNAL_TYPES_RUBETEK3434 = {
  1: 'Карты',
  2: 'Пин-код',
  3: 'Dtmf-код',
  4: 'Аналоговый',
  5: 'Внешнее',
  6: 'Panel web API',
  7: 'Карты (внешн)',
};

const JOURNAL_STATUS = {
  1: 'Открыто',
  0: 'Ошибка',
};
const JOURNAL_STATUS_BEWARD = {
  true: 'Открыто',
  false: 'Ошибка',
};

export {
  tempCodeProvisionHistoryHeaders,
  tempCodeProvisionHistoryHeadersWithAddress,
  actionsJournal, headersSipRV3434, CALL_TYPES, CALL_STATUS, JOURNAL_TYPES_RUBETEK3434, JOURNAL_STATUS_BEWARD,
  headersKeys, headersRulesRubetek3438, headersRulesRubetek3434, headersRulesBeward, headersJournalSip, headersJournal,
  headersRulesShortRubetek3434, headersRulesShortRubetek3438, headersRulesShortBeward,
  mobileHeadersJournal, headersJournalBeward, headersAbonent, headersDevice, headersSip, TYPE, JOURNAL_TYPES, JOURNAL_STATUS,
  headersSipBeward, headersJournal3434,
};
